import { render, staticRenderFns } from "./ExamExerciseDo.vue?vue&type=template&id=8a9ad75c&scoped=true&"
import script from "./ExamExerciseDo.vue?vue&type=script&lang=js&"
export * from "./ExamExerciseDo.vue?vue&type=script&lang=js&"
import style0 from "./ExamExerciseDo.vue?vue&type=style&index=0&id=8a9ad75c&lang=scss&scoped=true&"
import style1 from "./ExamExerciseDo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9ad75c",
  null
  
)

export default component.exports